import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const reasons = ['El ruido blanco genérico es muy agudo y termina irritando el sistema auditivo del bebé en lugar de calmarlo.', 'Mecerlo de forma errática envía señales de "peligro/movimiento" al cerebro en lugar de invitar a la relajación profunda.', 'Las rutinas rígidas de horarios no sirven si el ambiente sensorial del cuarto tiene "fugas de luz" que bloquean la melatonina.', 'El contacto visual excesivo durante la noche libera dopamina en el bebé, manteniéndolo despierto justo cuando quieres lo contrario.'];
export function WhyItDidntWork() {
  return <section className="py-24 px-6 bg-white" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown mb-4" data-id="element-201">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="text-lg text-brand-textLight" data-id="element-202">
            Las tácticas comunes ignoran cómo funciona realmente el cerebro de
            un bebé.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-203">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-cream/50 p-6 rounded-2xl flex items-start space-x-4 border border-brand-red/10" data-id="element-204">
              <div className="flex-shrink-0 mt-1" data-id="element-205">
                <XCircle className="w-6 h-6 text-brand-red" data-id="element-206" />
              </div>
              <p className="text-brand-text leading-relaxed" data-id="element-207">{reason}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}